import { ApplicationRef, DoBootstrap, NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  LocationStrategy,
  HashLocationStrategy,
  registerLocaleData,
  DatePipe,
  CurrencyPipe,
} from "@angular/common";

import { AppComponent } from "@app/app.component";
import { BsDropdownModule, ModalModule } from "ngx-bootstrap";
import { TabsModule } from "ngx-bootstrap/tabs";
import { NAV_DROPDOWN_DIRECTIVES } from "@app/shared/directive/nav-dropdown.directive";

import { SIDEBAR_TOGGLE_DIRECTIVES } from "@app/shared/directive/sidebar.directive";
import { AsideToggleDirective } from "@app/shared/directive/aside.directive";
import { BreadcrumbsComponent } from "@app/shared/components/breadcrumb.component";
import { UserCircleComponent } from "@app/shared/components/usercircle.component";
import { MenuComponent } from "@app/shared/components/menu.component";
import { ModaleErroreComponent } from "@app/shared/components/modale-errore/modale-errore.component";
import { SlimLoadingBarModule } from "ng2-slim-loading-bar";
import localeIt from "@angular/common/locales/it";
import localeItExtra from "@angular/common/locales/extra/it";
// Routing Module
import { AppRoutingModule } from "@app/app.routing";

// Layouts
import { FullLayoutComponent } from "@app/layouts/full-layout.component";
import { SimpleLayoutComponent } from "@app/layouts/simple-layout.component";

import { NotifierModule } from "angular-notifier";
import { FileUploadModule } from "ng2-file-upload";
import { FormsModule } from "@angular/forms";
import { MatTableModule } from "@angular/material";
import { KeycloakService, KeycloakAngularModule } from "keycloak-angular";
import { env } from "@env/environment";
import { SharedModule } from "@app/shared/shared.module";

const keycloakService: KeycloakService = new KeycloakService();


// tslint:disable-next-line:max-line-length

registerLocaleData(localeIt, "it-IT", localeItExtra);

@NgModule({
  imports: [
    FormsModule,
    FileUploadModule,
    MatTableModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    SlimLoadingBarModule.forRoot(),
    ModalModule.forRoot(),
    HttpClientModule,
    KeycloakAngularModule,
    SharedModule,
    NotifierModule.withConfig({
      position: {
        horizontal: {
          position: "right",
        },
        vertical: {
          position: "top",
        },
      },
    }),
  ],
  declarations: [
    AppComponent,
    FullLayoutComponent,
    SimpleLayoutComponent,
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    UserCircleComponent,
    MenuComponent,
    ModaleErroreComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
  ],
  providers: [
    DatePipe,
    CurrencyPipe,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    {
      provide: KeycloakService,
      useValue: keycloakService,
    },
  ],
  entryComponents: [AppComponent],
})
export class AppModule implements DoBootstrap {
  constructor() {}

  async ngDoBootstrap(appRef: ApplicationRef) {
    try {
      await keycloakService.init({
        config: {
          url: env.oauth2Url,
          realm: "rt",
          clientId: env.oauth2ClientId,
        },
        bearerPrefix: "Bearer ",
        enableBearerInterceptor: true,
        bearerExcludedUrls: ["/assets"],
        initOptions: {
          checkLoginIframe: false,
          useNonce: false
        },
        loadUserProfileAtStartUp: false,
      });
      console.log("[ngDoBootstrap] bootstrap app");
      appRef.bootstrap(AppComponent);
    } catch (error) {
      console.error("[ngDoBootstrap] init Keycloak failed", error);
    }
  }
}
